export default "__VITE_ASSET__CjZ8ZnrB__"